export const COUNTRY_INPUT_TK = "COUNTRY_INPUT_TK";
export const POS_INPUT_TK = "POS_INPUT_TK";
export const TOTAL_SWITCH_TK = "TOTAL_SWITCH_TK";
export const NESTED_SELECT_TK = "NESTED_SELECT_TK";
export const ONE_TIME_EXPLANATION_TK = "ONE_TIME_EXPLANATION_TK";
export const MAINTENANCE_ALERT_TK = "MAINTENANCE_ALERT_TK";
export const LOADING_FRAME_TK = "LOADING_FRAME_TK";
export const MAX_POS_FILTER_ALERT_TK = "MAX_POS_FILTER_ALERT_TK";
